import React from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import VTBuyDrink from "../page/VTBuyDrink";

export default function LandingBuyDrink() {
    return (
        <>
            <Header headerType="UserOnly"/>
            <VTBuyDrink/>
            <Footer/>
        </>
    );
}